import React from "react"
import PropTypes from "prop-types"
import {
  Form,
  Col,
  Input,
  FormGroup,
  Container,
  Row,
  Alert,
  Label,
} from "reactstrap"
import { Trans, useLingui } from "@lingui/react"
import { toast } from "react-toastify"
import {
  SuccessMessage,
  ErrorMessage,
} from "../../view/shared/notifications/Notifications"
import { selectVlsaFundAccounts } from "../../store/reducers/getVslas"
import { connect } from "react-redux"
import { updateGroupSettings } from "../../store/actions/createVsla"
import { defaultGroupSettings } from "../../view/shared/helpers"
import { t } from "@lingui/macro"
import StellarLoader from "../layout/StellarLoader"

const headerStyle = {
  color: "#E36F1E",
  fontFamily: "quicksand",
  fontSize: "1.8em",
  marginBottom: "0rem",
  fontWeight: "bolder",
  textAlign: "center",
}

const subheaderStyle = {
  fontFamily: "Fira Sans",
  fontSize: "20px",
  textAlign: "center",
  lineHeight: "1.5em",
}

const formStyle = {
  flex: "10",
  padding: "5px",
  fontFamily: "Fira Sans",
  fontSize: "20px",
  height: "50px",
}

const spanStyle = {
  padding: ".3rem",
  textAlign: "center",
  fontFamily: "Fira Sans",
  fontSize: "20px",
  color: "#696969",
}

const Settings = (props) => {
  const { i18n } = useLingui()

  const [isUpdating, setIsUpdating] = React.useState(false)
  const notify = (msg) => toast(msg)
  const [state, setState] = React.useState({
    share_value: "",
    savingsCashOutType:
      props.vsla?.metadata?.savingsCashOutType ||
      defaultGroupSettings["savingsCashOutType"],
    fineCashOutType:
      props.vsla?.metadata?.fineCashOutType ||
      defaultGroupSettings["fineCashOutType"],
    welfareCashOutType:
      props.vsla?.metadata?.welfareCashOutType ||
      defaultGroupSettings["welfareCashOutType"],
    membershipCashOutType:
      props.vsla?.metadata?.membershipCashOutType ||
      defaultGroupSettings["membershipCashOutType"],
    loanInterestCashOutType:
      props.vsla?.metadata?.loanInterestCashOutType ||
      defaultGroupSettings["loanInterestCashOutType"],
  })

  const onChange = (e) => setState({ ...state, [e.target.name]: e.target.value })

  const onSubmit = (e) => {
    e.preventDefault()
    setIsUpdating(true)
    updateSettingsApi(
      state.share_value,
      state.welfareCashOutType,
      state.membershipCashOutType,
      state.fineCashOutType,
      state.loanInterestCashOutType,
      state.savingsCashOutType,
    )
    setState({
      ...state,
      share_value: "",
      welfareCashOutType: "",
      fineCashOutType: "",
    })
  }

  const disableSubmit = () => {
    return (
      props.ongoingMeeting.length > 0 &&
      props.transactions.filter(
        ({ meetingId }) => parseInt(meetingId) === props.ongoingMeeting[0].id,
      ).length > 0
    )
  }

  const updateSettingsApi = async (
    share_value,
    welfareCashOutType,
    membershipCashOutType,
    fineCashOutType,
    loanInterestCashOutType,
    savingsCashOutType,
  ) => {
    const vsla = props.vsla
    let newVsla = Object.assign({}, vsla)
    newVsla.metadata.share_value =
      share_value === "" ? vsla?.metadata?.share_value : share_value
    newVsla.metadata.fineCashOutType =
      fineCashOutType === "" ? vsla.metadata?.fineCashOutType : fineCashOutType
    newVsla.metadata.welfareCashOutType =
      welfareCashOutType === ""
        ? vsla?.metadata?.welfareCashOutType
        : welfareCashOutType
    newVsla.metadata.membershipCashOutType =
      membershipCashOutType === ""
        ? vsla?.metadata?.membershipCashOutType
        : membershipCashOutType
    newVsla.metadata.loanInterestCashOutType =
      loanInterestCashOutType === ""
        ? vsla?.metadata?.loanInterestCashOutType
        : loanInterestCashOutType
    newVsla.metadata.savingsCashOutType =
      savingsCashOutType === ""
        ? vsla?.metadata?.savingsCashOutType
        : savingsCashOutType

    await props
      .updateSettings(newVsla)
      .then(async () => {
        setState({
          ...state,
          share_value: props.group?.cycle?.shareValue,
          welfareCashOutType: props.vsla?.metadata?.welfareCashOutType,
          memebershipCashOutType: props.vsla?.metadata?.membershipCashOutType,
          fineCashOutType: props.vsla?.metadata?.fineCashOutType,
          loanInterestCashOutType: props.vsla?.metadata?.loanInterestCashOutType,
          savingsCashOutType: props.vsla?.metadata?.savingsCashOutType,
        })
        notify(<SuccessMessage />)
        setState({ ...state, disableSubmit: false })
        setIsUpdating(false)
      })
      .catch((error) => {
        notify(<ErrorMessage />)
        throw new Error("Updating shares", error)
      })
  }

  if (isUpdating) {
    return <StellarLoader />
  }

  return (
    <Container>
      <div>
        <h4 style={headerStyle}>
          <Trans id="menu.settings">Settings</Trans>
        </h4>
      </div>
      <br />
      <div style={spanStyle}>
        <span>
          <Trans id="cards.share_value">Share Value</Trans>
        </span>
        {": "}
        {parseFloat(props.group?.cycle?.shareValue).toFixed(2)}
      </div>
      {!["ar", "lb"].includes(i18n.locale) && (
        <Row>
          <Col>
            <Form onSubmit={onSubmit}>
              <FormGroup>
                <Input
                  type="text"
                  name="share_value"
                  style={formStyle}
                  placeholder={t({ id: "Share Value Amount" })}
                  onChange={onChange}
                  values={state.share_value}
                  disabled={!props.group?.can_change_share_value}
                />
              </FormGroup>
              {disableSubmit() && (
                <span style={{ fontWeight: 600 }}>
                  {t({
                    id: "You cannot edit settings while there are pending transactions",
                  })}
                </span>
              )}
              <br />
              <h3 style={subheaderStyle}>
                <Trans id="Select Cash Out Type">Select Cash Out Type</Trans>
              </h3>
              <Label for="savingsCashOutType">
                <Trans id="menu.savingsFund">Savings Fund</Trans>
              </Label>
              <FormGroup>
                <Input
                  id="savings"
                  type="select"
                  name="savingsCashOutType"
                  style={formStyle}
                  onChange={onChange}
                  value={state.savingsCashOutType}
                // disabled={true}
                >
                  <option value="Shared based">
                    <Trans id="Shared Based">Shared Based</Trans>
                  </option>
                </Input>
              </FormGroup>
              {props.availableAccounts.includes("membership") && (
                <FormGroup>
                  <Label for="membershipCashOutType">
                    <Trans id="menu.membershipFund">Membership Fund</Trans>
                  </Label>
                  <Input
                    id="membership"
                    type="select"
                    name="membershipCashOutType"
                    style={formStyle}
                    onChange={onChange}
                    value={state.membershipCashOutType}
                  // disabled={true}
                  >
                    <option value="Refund">
                      <Trans id="Refund">Refund</Trans>
                    </option>
                  </Input>
                </FormGroup>
              )}
              {props.availableAccounts.includes("welfare") && (
                <FormGroup>
                  <Label for="welfareCashOutType">
                    <Trans id="menu.welfareFund">Welfare Fund</Trans>
                  </Label>
                  <Input
                    id="welfare"
                    type="select"
                    name="welfareCashOutType"
                    style={formStyle}
                    onChange={onChange}
                    value={state.welfareCashOutType}
                  >
                    {/* <option value="">{welfareCashOutTypes}</option> */}
                    {/* <option value="Share based">{sharedBased}</option> */}
                    <option value="Equally">
                      <Trans id="Equally">Equally</Trans>
                    </option>
                    {/* <option value="Refund">{refund}</option> */}
                  </Input>
                </FormGroup>
              )}

              {props.availableAccounts.includes("fine") && (
                <FormGroup>
                  <Label for="fineCashOutType">
                    <Trans id="menu.fineFund">Fine Fund</Trans>
                  </Label>
                  <Input
                    id="fine"
                    type="select"
                    name="fineCashOutType"
                    style={formStyle}
                    onChange={onChange}
                    value={state.fineCashOutType}
                  >
                    {/* <option value="">{fineCashOutType}</option>*/}
                    <option value="Share based">
                      <Trans id="Shared Based">Shared Based</Trans>
                    </option>
                    <option value="Equally">
                      <Trans id="Equally">Equally</Trans>
                    </option>
                    {/* <option value="Refund">{refund}</option> */}
                  </Input>
                </FormGroup>
              )}

              {props.availableAccounts.includes("loan_interest") && (
                <FormGroup>
                  <Label for="loanInterestCashOutType">
                    <Trans id="menu.loanInterestFund">Loan Interest Fund</Trans>
                  </Label>
                  <Input
                    type="select"
                    id="loan_interest"
                    name="loanInterestCashOutType"
                    style={formStyle}
                    onChange={onChange}
                    value={state.loanInterestCashOutType}
                  >
                    {/* <option value="">{fineCashOutType}</option> */}
                    <option value="Share based">
                      <Trans id="Shared Based">Shared Based</Trans>
                    </option>
                    {/* <option value="Equally">{equally}</option> */}
                    {/* <option value="Refund">{refund}</option> */}
                  </Input>
                </FormGroup>
              )}
              <FormGroup>
                <Input
                  type="submit"
                  value={t({ id: "Submit" })}
                  name="submit"
                  className="btn btn-primary"
                  disabled={!isUpdating ? disableSubmit() : true}
                />
              </FormGroup>
            </Form>
          </Col>
        </Row>
      )}
      <div>
        {props.ongoingMeeting.length > 0 && (
          <Alert color="warning">
            <span
              style={{
                fontFamily: "Fira Sans",
                fontSize: "16px",
              }}
            >
              <Trans id="Cannot update share value while a meeting is ongoing">
                Cannot update share value while a meeting is ongoing
              </Trans>
            </span>
          </Alert>
        )}
      </div>
    </Container>
  )
}

Settings.propTypes = {
  vsla: PropTypes.object,
  ongoingMeeting: PropTypes.array,
  transactions: PropTypes.array,
  group: PropTypes.object,
  updateSettings: PropTypes.func,
  availableAccounts: PropTypes.array,
}

const mapStateToProps = (state) => {
  return {
    ongoingMeeting: state.currentOngoingMeeting,
    transactions: state.meetingTransactions,
    share_value: state.vsla?.metadata?.share_value,
    vsla: state.vsla,
    availableAccounts: selectVlsaFundAccounts(state),
    group: state.group,
    user: state.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateSettings: (data) => dispatch(updateGroupSettings(data)),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Settings)
